import app from 'flarum/admin/app';
import { extend } from 'flarum/common/extend';
import AdminNav from 'flarum/admin/components/AdminNav';
import LinkButton from 'flarum/common/components/LinkButton';
export default function extendAdminNav() {
  extend(AdminNav.prototype, 'items', function (items) {
    items.add('gdpr', m(LinkButton, {
      href: app.route('gdpr'),
      icon: "fas fa-user-shield",
      title: app.translator.trans('flarum-gdpr.admin.nav.gdpr_title')
    }, app.translator.trans('flarum-gdpr.admin.nav.gdpr_button')), 48);
  });
}